import * as React from 'react';

import BingoInfo from '../../game-tile/BingoInfo';
import Grid, { GridProps } from '../Grid/Grid';
import { GameTileProps } from '../types';

import styles from './ExtendedGrid.module.scss';

interface ExtendedGridProps extends GridProps {}

const renderBingoInfo = (game: GameTileProps) => {
  const getExtendedInfoComponent = () => {
    if (game.bingo) return <BingoInfo bingoData={game.bingo} />;

    return <h4 className={styles.title}>{game.title}</h4>;
  };

  return (
    <div className={styles.extendedInfo}>{getExtendedInfoComponent()}</div>
  );
};

const ExtendedGrid: React.FC<ExtendedGridProps> = props => {
  return <Grid {...props} renderExtendedInfo={renderBingoInfo} />;
};

export default ExtendedGrid;
